import { useNavigation } from "../../hooks/useNavigation";
import { Button } from "../atoms/Button";

export const BackToTopPageButton: React.FC = () => {
  const { navigateToTopPage } = useNavigation();

  return (
    <Button
      btnStyle="secondary"
      text="トップページへ戻る"
      onClick={navigateToTopPage}
    />
  );
};
